var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useRef, useState } from 'react';
import { Dropdown } from 'antd';
import { CaretDownOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useQueryClient } from 'react-query';
import services from 'services';
import EmptyComponent from 'components/EmptyComponent';
import DataTable from 'library/components/DataTable';
import { Chip, monoColumn, Muted, NameText, statusColumn } from 'library/components/DataTable/cells';
import ListScreen, { listPager } from 'library/components/ListScreen';
import localeTranslator from 'library/Hocs/LocalTranslator';
import { exportTableToPDF } from 'library/utilities/ExportTableToPDF';
var textOf = function (value) { return (value == null ? '' : String(value)); };
var stockStatus = function (stock) { return stock.getQuantity() > 0; };
var Stocks = function (props) {
    var t = props.translate;
    var queryClient = useQueryClient();
    var stockService = services.stockService, clinicService = services.clinicService, permissionService = services.permissionService;
    var canAudit = permissionService.hasPermissionToStockAudit();
    var _a = useState(1), pageNumber = _a[0], setPageNumber = _a[1];
    var _b = useState(''), searchValue = _b[0], setSearchValue = _b[1];
    var debounceRef = useRef(undefined);
    var clinics = clinicService.useClinics().data;
    var _c = stockService.useStocks(pageNumber), data = _c.data, isLoading = _c.isLoading;
    var stocks = (data === null || data === void 0 ? void 0 : data.stocks) || [];
    var meta = data === null || data === void 0 ? void 0 : data.meta;
    var page = Number((meta === null || meta === void 0 ? void 0 : meta.page) || pageNumber);
    var pages = Math.max(1, Number((meta === null || meta === void 0 ? void 0 : meta.pages) || 1));
    var total = Number((meta === null || meta === void 0 ? void 0 : meta.count) || stocks.length);
    var from = Number((meta === null || meta === void 0 ? void 0 : meta.from) || (stocks.length ? 1 : 0));
    var to = Number((meta === null || meta === void 0 ? void 0 : meta.to) || stocks.length);
    var visible = useMemo(function () {
        var query = searchValue.trim().toLowerCase();
        if (!query)
            return stocks;
        return stocks.filter(function (stock) {
            var _a, _b, _c;
            return [
                stock.getId(),
                (_a = stock.getLocation()) === null || _a === void 0 ? void 0 : _a.getName(),
                (_b = stock.getProduct()) === null || _b === void 0 ? void 0 : _b.getName(),
                (_c = stock.getProduct()) === null || _c === void 0 ? void 0 : _c.getSystemCode()
            ]
                .join(' ')
                .toLowerCase()
                .includes(query);
        });
    }, [stocks, searchValue]);
    var onSearchValueChange = function (event) {
        var value = event.target.value;
        clearTimeout(debounceRef.current);
        debounceRef.current = setTimeout(function () { return setSearchValue(value); }, 300);
    };
    var startPDFExporting = function (locationId, locationName) { return __awaiter(void 0, void 0, void 0, function () {
        var audit;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, stockService.fetchStockAudit(queryClient, locationId)];
                case 1:
                    audit = _a.sent();
                    if (!audit)
                        return [2 /*return*/];
                    return [4 /*yield*/, exportTableToPDF({
                            columns: [
                                { title: t('id'), dataIndex: 'id', key: 'id' },
                                { title: t('location'), dataIndex: 'location', key: 'location' },
                                { title: t('product'), dataIndex: 'product', key: 'product' },
                                { title: t('quantity'), dataIndex: 'quantity', key: 'quantity' },
                                { title: t('pendingQuantity'), dataIndex: 'pendingQuantity', key: 'pendingQuantity' }
                            ],
                            fetchAllData: function () { return Promise.resolve(audit.map(function (record) { return record.getPDFRecord(); })); },
                            fileName: "stock-audit-".concat(locationId, ".pdf"),
                            kicker: t('title'),
                            title: t('auditTitle'),
                            meta: t('auditMeta', {
                                location: locationName,
                                date: dayjs().format('D MMM YYYY, HH:mm')
                            })
                        })];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var auditItems = canAudit
        ? (clinics || []).map(function (location) { return ({
            key: "location-".concat(location.getId()),
            label: location.getName(),
            onClick: function () { return startPDFExporting(location.getId(), location.getName() || ''); }
        }); })
        : [];
    var columns = useMemo(function () { return [
        monoColumn({ key: 'id', title: t('id'), width: '72px', variant: 'id', value: function (stock) { return stock.getId(); } }),
        { key: 'location', title: t('location'), width: 'minmax(140px, 1fr)', render: function (stock) { var _a; return _jsx(NameText, { children: textOf((_a = stock.getLocation()) === null || _a === void 0 ? void 0 : _a.getName()) }); } },
        {
            key: 'product',
            title: t('product'),
            width: 'minmax(180px, 1.4fr)',
            render: function (stock) {
                var _a, _b;
                var systemCode = textOf((_a = stock.getProduct()) === null || _a === void 0 ? void 0 : _a.getSystemCode());
                return (_jsxs("div", { className: "cidx-stack", children: [_jsx(NameText, { children: textOf((_b = stock.getProduct()) === null || _b === void 0 ? void 0 : _b.getName()) }), systemCode ? _jsx("span", { className: "cidx-stack__sub", children: systemCode }) : null] }));
            }
        },
        monoColumn({ key: 'qty', title: t('quantity'), width: '120px', value: function (stock) { return textOf(stock.getQuantity()); } }),
        statusColumn({
            title: t('status'),
            width: '140px',
            active: stockStatus,
            activeLabel: t('inStock'),
            inactiveLabel: t('outOfStock')
        }),
        {
            key: 'pending',
            title: t('pendingQuantity'),
            width: '140px',
            render: function (stock) {
                var pending = stock.getPendingQuantity();
                return pending > 0 ? _jsx(Chip, { tone: "is-amber", children: pending }) : _jsx(Muted, { children: "0" });
            }
        }
    ]; }, [t]);
    return (_jsx(ListScreen, { title: t('title'), count: t('countBadge', { count: total }), subtitle: t('subtitle'), actions: auditItems.length > 0 ? (_jsx(Dropdown, { menu: { items: auditItems }, placement: "bottomRight", children: _jsxs("button", { type: "button", className: "cidx-btn cidx-btn--secondary", children: [_jsx(CaretDownOutlined, {}), _jsx("span", { children: t('common:buttons.audit') })] }) })) : undefined, search: { placeholder: t('searchPlaceholder'), onChange: onSearchValueChange }, children: _jsx(DataTable, { minWidth: "860px", loading: isLoading, rows: visible, rowKey: function (stock) { return stock.getId(); }, empty: _jsx(EmptyComponent, { description: t('empty') }), columns: columns, pager: listPager({
                total: total,
                page: page,
                pages: pages,
                meta: searchValue.trim() ? t('matchesOnPage', { count: visible.length }) : t('showingRange', { from: from, to: to, total: total }),
                previous: t('previous'),
                next: t('next'),
                center: t('pageOf', { page: page, pages: pages }),
                setPage: setPageNumber
            }) }) }));
};
export default localeTranslator(Stocks, 'stocks');
